import { subYears } from 'date-fns';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, NothingHere } from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';
import { DisplaysStore } from './DisplaysStore';
import { MinMaxItem } from './MinMaxItem';

export interface IDisplayMinMaxListParams {
    serialNumber: string;
}
export interface IDisplayMinMaxListProps extends RouteComponentProps<IDisplayMinMaxListParams> {}

@autoinject
@observer
export class MinMaxList extends React.Component<IDisplayMinMaxListProps> {
    public constructor(props: IDisplayMinMaxListProps) {
        super(props);

        const startTime = this.formStore.fields.startTime.value;
        startTime.setMonth(startTime.getMonth() - 1);

        const endTime = this.formStore.fields.endTime.value;
        endTime.setDate(endTime.getDate() + 1);
        endTime.setMinutes(59);
        endTime.setSeconds(59);
    }

    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.displaysStore.loadAsync(this.props.match.params.serialNumber);
            await this.getMinMaxAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 p-0">
                        <table className="table table-responsive-md">
                            <thead>
                                <tr>
                                    <th className="w-25">Sensor</th>
                                    <th>Lifetime Min</th>
                                    <th>Lifetime Max</th>
                                    <th>Daily Min</th>
                                    <th>Daily Max</th>
                                    <th className="w-25">Sensor Graph (7d)</th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.minMax.map(m => (
                                    <MinMaxItem
                                        minMaxModel={m}
                                        key={m.sensorId}
                                        serialNumber={this.props.match.params.serialNumber}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <NothingHere
                    empty={!this.minMax.length}
                    icon={<BsCardHeading />}
                    loading={this.loading}
                    loadingMessage="Loading Data..."
                    label="No Data Available"
                />
            </div>
        );
    }

    @bind
    @action
    private async getMinMaxAsync() {
        this.loading = true;
        try {
            const minMax = await this.displaysStore.getMinMaxLogAsync(
                this.props.match.params.serialNumber,
                this.formStore.values.startTime,
                this.formStore.values.endTime
            );

            if (minMax) this.minMax = minMax;
        } catch (e: any) {
            console.error(e);
        } finally {
            this.loading = false;
        }
    }

    private formStore = new FormStore({
        startTime: subYears(new Date(), 1),
        endTime: new Date(),
    });

    @observable
    private loading = false;
    @observable
    private minMax: Mri.Web.Portal.Controllers.Displays.MinMaxModel[] = [];
    @inject
    private displaysStore!: DisplaysStore;
    @inject
    private appStore!: AppStore;
}
